import { formatMoney } from "@/components/clinic-health-calculator/ClinicHealthCalculator";

// Profit strip: Money In, Expenses, Net. All amounts come straight from the
// server-computed `totals` payload — nothing is recalculated client-side.
export default function ProfitStrip({ totals, currency, canViewSensitive }) {
  const safeTotals = totals || {};
  const moneyIn = Number(safeTotals.cash_in_centavos || 0);
  const expenses = Number(safeTotals.total_expenses_centavos || 0);
  const net = Number(safeTotals.net_profit_centavos || 0);
  const restrictedCount = Number(safeTotals.restricted_count || 0);
  const showRestrictedNote = restrictedCount > 0 && !canViewSensitive;

  return (
    <section className="space-y-2">
      <div className="grid gap-3 sm:grid-cols-3">
        <Tile label="Money In" value={formatMoney(moneyIn, currency)} />
        <Tile label="Expenses" value={formatMoney(expenses, currency)} />
        <Tile
          label="Net"
          value={formatMoney(net, currency)}
          valueTestId="expenses-net"
          valueClassName={net >= 0 ? "text-emerald-700" : "text-rose-700"}
        />
      </div>
      {showRestrictedNote ? (
        <p
          data-testid="expenses-restricted-note"
          className="text-[12px] font-medium text-slate-500"
        >
          Includes {restrictedCount} restricted line{restrictedCount === 1 ? "" : "s"} you don't have access to view.
        </p>
      ) : null}
    </section>
  );
}

function Tile({ label, value, valueClassName = "text-slate-950", valueTestId }) {
  return (
    <div className="rounded-lg border border-slate-200 bg-white p-4">
      <div className="text-[11px] font-semibold uppercase tracking-wide text-slate-500">{label}</div>
      <div
        data-testid={valueTestId}
        className={`mt-1 text-[22px] font-bold tabular-nums ${valueClassName}`}
      >
        {value}
      </div>
    </div>
  );
}
